import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, operators, activeOperator } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontFamily: 'IBM Plex Sans, sans-serif'
      }}>
        <div style={{ fontSize: '1.125rem', color: '#555555' }}>Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'trabajador' && !location.pathname.startsWith('/produccion')) {
    return <Navigate to="/produccion" replace />;
  }

  if (user.role !== 'trabajador' && location.pathname.startsWith('/produccion/trabajador')) {
    return <Navigate to="/produccion" replace />;
  }

  if (operators.length > 1 && !activeOperator && location.pathname !== '/seleccionar-operador') {
    return <Navigate to="/seleccionar-operador" replace />;
  }

  return children;
};

export default ProtectedRoute;
